module.exports = __webpack_public_path__ + "static/media/logo_white.ef77b1c7.svg";